import { AgendaComponent } from './agenda/agenda.component'
import { APP_INITIALIZER, NgModule } from '@angular/core'
import { AppComponent } from './app.component'
import { AppRoutingModule } from './app-routing.module'
import { AuthModule } from '@auth0/auth0-angular'
import { BottomSheetItemDetailComponent } from './bottom-sheet-item-detail/bottom-sheet-item-detail.component'
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations'
import { BrowserModule, HammerModule } from '@angular/platform-browser'
import { CacheLocation } from '@auth0/auth0-spa-js'
import { CachingInterceptorService } from './services/cache-interceptor.service'
import { CallbackPipe } from 'src/utilities/callback.pipe'
import { Capacitor } from '@capacitor/core'
import { CarouselComponent } from './carousel/carousel.component'
import { ClipboardModule } from '@angular/cdk/clipboard'
import { CompleteComponent } from './quiz/complete/complete.component'
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component'
import { CookieModule } from 'ngx-cookie'
import { CourseComponent } from './course/course.component'
import { CustomRoadmap } from './roadmap/custom/custom.component'
import { DailyRoadmap } from './roadmap/daily/daily.component'
import { DelphireInitializationService } from './services/delphire-initialization.service'
import { environment } from '../environments/environment'
import { File } from '@ionic-native/file/ngx'
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx'
import { FileSizePipe } from '../utilities/file-size.pipe'
import { FIREBASE_OPTIONS } from '@angular/fire/compat'
import { FirebaseService } from './services/firebase.service'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FooterComponent } from './footer/footer.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { FromPipe } from '../utilities/from.pipe'
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics'
import { getApp } from '@firebase/app'
import { getAuth, provideAuth } from '@angular/fire/auth'
import { getDatabase, provideDatabase } from '@angular/fire/database'
import { getFirestore, provideFirestore } from '@angular/fire/firestore'
import { getStorage, provideStorage } from '@angular/fire/storage'
import { GroupService } from './services/group-service'
import { HeaderComponent } from './header/header.component'
import {
  HeroAcademicCap,
  HeroAcademicCapSolid,
  HeroArrowsExpand,
  HeroBadgeCheck,
  HeroBan,
  HeroBellSolid,
  HeroChat,
  HeroChatSolid,
  HeroCheckCircle,
  HeroCheckCircleSolid,
  HeroChevronLeft,
  HeroChevronLeftSolid,
  HeroChevronRight,
  HeroChevronRightSolid,
  HeroClock,
  HeroClockSolid,
  HeroCloud,
  HeroCollection,
  HeroCollectionSolid,
  HeroCube,
  HeroCubeSolid,
  HeroDesktopComputer,
  HeroDocumentText,
  HeroDocumentTextSolid,
  HeroDuplicate,
  HeroDuplicateSolid,
  HeroExternalLink,
  HeroExternalLinkSolid,
  HeroFlagSolid,
  HeroFolderDownload,
  HeroFolderDownloadSolid,
  HeroGlobeAltSolid,
  HeroHomeSolid,
  HeroLibrary,
  HeroLibrarySolid,
  HeroLogoutSolid,
  HeroMap,
  HeroMapSolid,
  HeroMicrophone,
  HeroMicrophoneSolid,
  HeroPaperAirplane,
  HeroPhotograph,
  HeroPhotographSolid,
  HeroStar,
  HeroStarSolid,
  HeroSun,
  HeroSunSolid,
  HeroTemplate,
  HeroTemplateSolid,
  HeroUsers,
  HeroUsersSolid,
  HeroVideoCamera,
  HeroVideoCameraSolid
  } from '@ng-icons/heroicons'
import { HomePageComponent } from './home-page/home-page.component'
import { HTTP } from '@awesome-cordova-plugins/http/ngx'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx'
import { indexedDBLocalPersistence, initializeAuth } from 'firebase/auth'
import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { LandingComponent } from './quiz/landing/landing.component'
import { LayoutComponent } from './layout/layout.component'
import { LayoutDetailComponent } from './layout-detail/layout-detail.component'
import { LibraryComponent } from './library/library.component'
import { LibraryNamePipe } from '../utilities/library-name.pipe'
import { MatBadgeModule } from '@angular/material/badge'
import { MatBottomSheetModule } from '@angular/material/bottom-sheet'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatChipsModule } from '@angular/material/chips'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatGridListModule } from '@angular/material/grid-list'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatListModule } from '@angular/material/list'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatSortModule } from '@angular/material/sort'
import { MatTableModule } from '@angular/material/table'
import { MatTabsModule } from '@angular/material/tabs'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MdbAccordionModule } from 'mdb-angular-ui-kit/accordion'
import { MdbCarouselModule } from 'mdb-angular-ui-kit/carousel'
import { MdbCheckboxModule } from 'mdb-angular-ui-kit/checkbox'
import { MdbCollapseModule } from 'mdb-angular-ui-kit/collapse'
import { MdbDropdownModule } from 'mdb-angular-ui-kit/dropdown'
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms'
import { MdbModalModule } from 'mdb-angular-ui-kit/modal'
import { MdbPopoverModule } from 'mdb-angular-ui-kit/popover'
import { MdbRadioModule } from 'mdb-angular-ui-kit/radio'
import { MdbRangeModule } from 'mdb-angular-ui-kit/range'
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple'
import { MdbScrollspyModule } from 'mdb-angular-ui-kit/scrollspy'
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs'
import { MdbTooltipModule } from 'mdb-angular-ui-kit/tooltip'
import { MdbValidationModule } from 'mdb-angular-ui-kit/validation'
import { MdePopoverModule } from '@material-extended/mde'
import { ModuleComponent } from './module/module.component'
import { MyLearningsComponent } from './my-learnings/my-learnings.component'
import { NavigationService } from './services/navigation.service'
import { NgHttpLoaderModule } from 'ng-http-loader'
import { NgIconsModule } from '@ng-icons/core'
import { NotificationsComponent } from './notifications/notifications.component'
import { OrderByPipe } from '../utilities/OrderByPipe'
import { OrganizationService } from './services/delphire-organization.service'
import { PageNotFoundComponent } from './page-not-found/page-not-found.component'
import { PdfTrackingService } from './services/pdf-tracking.service'
import { ProgressService } from './services/tracking/progress.service'
import { PSPDFKit } from '@awesome-cordova-plugins/pspdfkit-cordova/ngx'
import { QuestionComponent } from './quiz/question/question.component'
import { QuizComponent } from './quiz/quiz.component'
import { RecommendationsComponent } from './recommendations/recommendations.component'
import { RoadmapComponent } from './roadmap/roadmap.component'
import { SafePipe } from '../utilities/safe.pipe'
import { ScormCompletionComponent } from './scorm-completion/scorm-completion.component'
import { SearchComponent } from './search/search.component'
import { SelfCompleteDialog, TaskComponent } from './task/task.component'
import { ServiceWorkerModule } from '@angular/service-worker'
import { ShowMoreDirective } from './directives/show-more.directive'
import { SpaceComponent } from './space/space.component'
import { TaskCardComponent } from './task-card/task-card.component'
import { TimeFormatPipe } from '../utilities/time-format.pipe'
import { TrackableDocumentModalComponent } from './trackable-document-modal/trackable-document-modal.component'
import { TrackableMultiMediaModalComponent } from './trackable-multimedia-modal/trackable-multimedia-modal.component'
import { TrackService } from './services/tracking/track.service'
import { UserService } from './services/delphire-user.service'
import { WeeklyRoadmap } from './roadmap/weekly/weekly.component'
import { WidgetComponent } from './widget/widget.component'
import { WindowRef } from './services/window-ref.service'
import { Zip } from '@ionic-native/zip/ngx'
import '../polyfills'



const cacheLocation: CacheLocation = 'localstorage'
export const authConfig = Capacitor.isNativePlatform()
  ? {
      domain: environment.authConfig.domain,
      clientId: environment.authConfig.clientId,
      audience: environment.authConfig.audience,
      scope: 'openid email profile',
      cacheLocation: cacheLocation,
      useRefreshTokens: true,
      redirectUri: `${environment.urlScheme}://${environment.authConfig.domain}/capacitor/${environment.urlScheme}/callback`
    }
  : {
      domain: environment.authConfig.domain,
      clientId: environment.authConfig.clientId,
      audience: environment.authConfig.audience,
      responseType: 'token id_token',
      cacheLocation: cacheLocation
    }

export function initAppUser(
  delphireInitializationService: DelphireInitializationService
) {
  return () => delphireInitializationService.initialize()
}

@NgModule({
  declarations: [
    HeaderComponent,
    AppComponent,
    PageNotFoundComponent,
    ConfirmationDialogComponent,
    OrderByPipe,
    CallbackPipe,
    SpaceComponent,
    LayoutComponent,
    LayoutDetailComponent,
    WidgetComponent,
    FooterComponent,
    RoadmapComponent,
    TaskComponent,
    SelfCompleteDialog,
    TrackableDocumentModalComponent,
    ModuleComponent,
    SafePipe,
    LibraryComponent,
    MyLearningsComponent,
    CourseComponent,
    QuizComponent,
    SearchComponent,
    NotificationsComponent,
    TrackableMultiMediaModalComponent,
    FileSizePipe,
    CarouselComponent,
    LandingComponent,
    CompleteComponent,
    QuestionComponent,
    BottomSheetItemDetailComponent,
    HomePageComponent,
    TimeFormatPipe,
    TaskCardComponent,
    LibraryNamePipe,
    ShowMoreDirective,
    DailyRoadmap,
    WeeklyRoadmap,
    CustomRoadmap,
    FromPipe,
    ScormCompletionComponent,
    RecommendationsComponent,
    AgendaComponent

  ],
  entryComponents: [ConfirmationDialogComponent],
  imports: [
    provideFirebaseApp(() => {
      return initializeApp(environment.firebaseConfig)
    }),
    provideFirestore(() => {
      const firestore = getFirestore()
      // enableIndexedDbPersistence(firestore)
      return firestore
    }),
    provideDatabase(() => getDatabase()),
    provideStorage(() => getStorage()),
    provideAnalytics(() => getAnalytics()),
    provideAuth(() => {
      if (Capacitor.isNativePlatform()) {
        return initializeAuth(getApp(), {
          persistence: indexedDBLocalPersistence
        })
      } else {
        return getAuth()
      }
    }),
    BrowserModule,
    HttpClientModule,
    AuthModule.forRoot(authConfig),
    NgHttpLoaderModule.forRoot(),
    NgIconsModule.withIcons({
      HeroBellSolid,
      HeroGlobeAltSolid,
      HeroLogoutSolid,
      HeroLibrarySolid,
      HeroMapSolid,
      HeroChat,
      HeroCheckCircleSolid,
      HeroDocumentTextSolid,
      HeroVideoCameraSolid,
      HeroAcademicCap,
      HeroAcademicCapSolid,
      HeroBadgeCheck,
      HeroBan,
      HeroCheckCircle,
      HeroChevronLeft,
      HeroChevronLeftSolid,
      HeroChevronRight,
      HeroChevronRightSolid,
      HeroClock,
      HeroClockSolid,
      HeroCloud,
      HeroCollection,
      HeroCollectionSolid,
      HeroCube,
      HeroCubeSolid,
      HeroDesktopComputer,
      HeroDocumentText,
      HeroDuplicate,
      HeroDuplicateSolid,
      HeroArrowsExpand,
      HeroExternalLink,
      HeroExternalLinkSolid,
      HeroFlagSolid,
      HeroFolderDownload,
      HeroFolderDownloadSolid,
      HeroHomeSolid,
      HeroLibrary,
      HeroMap,
      HeroMicrophone,
      HeroMicrophoneSolid,
      HeroPaperAirplane,
      HeroPhotograph,
      HeroPhotographSolid,
      HeroStar,
      HeroStarSolid,
      HeroSun,
      HeroSunSolid,
      HeroTemplate,
      HeroTemplateSolid,
      HeroUsers,
      HeroUsersSolid,
      HeroVideoCamera,
      HeroChatSolid,
    }),
    AppRoutingModule,
    BrowserAnimationsModule,
    MdePopoverModule,
    ClipboardModule,
    HammerModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatChipsModule,
    MatBottomSheetModule,
    MatFormFieldModule,
    MatBadgeModule,
    MatTabsModule,
    MatTableModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatDialogModule,
    MatSortModule,
    MatGridListModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatListModule,
    FlexLayoutModule,
    MdbAccordionModule,
    MdbCarouselModule,
    MdbCheckboxModule,
    MdbCollapseModule,
    MdbDropdownModule,
    MdbFormsModule,
    MdbModalModule,
    MdbPopoverModule,
    MdbRadioModule,
    MdbRangeModule,
    MdbRippleModule,
    MdbScrollspyModule,
    MdbTabsModule,
    MdbTooltipModule,
    MdbValidationModule,
    NoopAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    CookieModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initAppUser,
      deps: [DelphireInitializationService],
      multi: true
    },
    { provide: FIREBASE_OPTIONS, useValue: environment.firebaseConfig },
    FirebaseService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CachingInterceptorService,
      multi: true
    },
    TrackService,
    ProgressService,
    OrganizationService,
    GroupService,
    UserService,
    NavigationService,
    ScreenTrackingService,
    UserTrackingService,
    InAppBrowser,
    Zip,
    File,
    FileOpener,
    PSPDFKit,
    WindowRef,
    PdfTrackingService,
    HTTP
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
